import { Component, Input } from '@angular/core';
import { KpiDataPoint, KpiSummaryData } from '../../../../redux/models/statistics/kpi-summary-data';

@Component({
  standalone: false,
  selector: 'app-kpi-summary',
  templateUrl: './kpi-summary.component.html',
  styleUrls: ['./kpi-summary.component.scss']
})
export class KpiSummaryComponent {

  @Input() public kpiSummaryData: KpiSummaryData[] = [];

  readonly labels = {
    [KpiDataPoint.AVERAGE_BOOKING_VALUE]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.average-booking-value:Average booking value`,
    [KpiDataPoint.AVERAGE_LEAD_TIME_IN_DAYS]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.average-lead-time-in-days:Average lead time (days)`,
    [KpiDataPoint.AVERAGE_LENGTH_OF_STAY_IN_NIGHTS]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.average-length-of-stay-in-nights:Average length of stay (nights)`,
    [KpiDataPoint.AVERAGE_MARK_UP]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.average-mark-up:Average mark-up`,
    [KpiDataPoint.TOTAL_BOOKINGS]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.total-bookings:Total bookings`,
    [KpiDataPoint.TOTAL_GROSS_SALES_REVENUE]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.total-gross-sales-revenue:Total gross sales revenue`,
    [KpiDataPoint.TOTAL_NET_REVENUE]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.total-net-revenue:Total net revenue`,
    [KpiDataPoint.TOTAL_NIGHTS]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.total-nights:Total nights`,
    [KpiDataPoint.TOTAL_REVENUE]: $localize`:@@amadeus-direct.avc-dashboard.kpi-datapoint-type.total-revenue:Total revenue`
  };
}
